const BackgroundOrbs = () => (
  <div className="fixed inset-0 pointer-events-none z-0" style={{ background: '#FAFAF7' }} />
);

export default BackgroundOrbs;
